import React from 'react'
import {connect} from 'react-redux';
import PostList from './postList';
import { Container } from 'components';
import { notify } from 'actions';
import moment from 'moment';
import * as Api from 'api';

class PostListContainer extends React.Component {
  state = { posts: [ ] };
  updatePosts = () => {
    Api.fetchPosts()
		.then(posts => this.setState({posts: posts.results}))
		.catch(e => {'ERROR RECEIVING POSTS : ', e});
  }
  handleSuccessfulDelete = () => {
    this.updatePosts();
  }
  handleDeletePost = () => {
    const _self = this;
		Api.deletePost(id)
		.then(this.handleSuccessfulDelete)
		.catch(e => {
			console.log('ERROR DELETING POST : ', e);
			_self.props.notify({ message : 'Error deleting post.' });
		});
  }
  handleAddPost = () => {
    this.props.history.push('/posts/create');
  }
  componentDidMount() {
    this.updatePosts();
  }
  render() {
    var posts = this.state.posts;
    return (
			<Container title='Posts'>
				<section className="panel">
					<header className="panel-heading">
						<h2 className="panel-title">All Posts</h2>
					</header>
					<div className="panel-body">
						<div className="row">
							<div className="col-sm-6">
								<div className="mb-md">
									<button id="addToTable" onClick={this.handleAddPost} className="btn btn-primary">Add <i className="fa fa-plus"></i></button>
								</div>
							</div>
						</div>
						<table className="table table-bordered table-striped mb-none" id="datatable-editable">
							<thead>
								<tr>
									<th>Title</th>
									<th>Excerpt</th>
									<th>Author</th>
									<th>Last Edit</th>
									<th>Actions</th>
								</tr>
							</thead>
							<PostList posts={posts} handleAddPost={this.handleAddPost} handleDeletePost={this.handleDeletePost}/>
						</table>
					</div>
				</section>
			</Container>
    );
  }
}

var mapStateToProps = function(state){
	return { connection : state.connection };
}

module.exports = connect(mapStateToProps, { notify })(PostListContainer);



// WEBPACK FOOTER //
// ./src/browser/components/posts/postListContainer.js